import { formatAge, localTime, minutesToHHMM } from '@pace/domain';

/** Server clock offset, so ages and "since" times match the server on phones with wrong clocks. */
let offset = 0;
export const syncServerTime = (serverTime: number, sentAt = Date.now()) => {
  offset = Math.round(serverTime - (sentAt + Date.now()) / 2);
};
export const now = () => Math.round(Date.now() + offset);

export const hhmm = (ms: number | null | undefined, tz: string): string =>
  ms == null ? '—' : minutesToHHMM(localTime(ms, tz).minutes);

export const age = (since: number, at = now()): string => formatAge(at - since);

const dayFmt = new Map<string, Intl.DateTimeFormat>();
/** "Thu 24 Sep" in the chosen language (date is a plant-local YYYY-MM-DD). */
export function fmtDate(date: string, lang: 'en' | 'hi', withYear = false): string {
  const key = `${lang}:${withYear}`;
  let f = dayFmt.get(key);
  if (!f) {
    f = new Intl.DateTimeFormat(lang === 'hi' ? 'hi-IN' : 'en-GB', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      ...(withYear ? { year: 'numeric' } : {}),
      timeZone: 'UTC',
    });
    dayFmt.set(key, f);
  }
  return f.format(new Date(`${date}T00:00:00Z`));
}

export function fmtDateTime(ms: number, tz: string, lang: 'en' | 'hi'): string {
  return new Intl.DateTimeFormat(lang === 'hi' ? 'hi-IN' : 'en-GB', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
    timeZone: tz,
  }).format(new Date(ms));
}

const shortFmt = new Map<string, Intl.DateTimeFormat>();
/** "12 May" (or "12 May 26" with the year) — compact dates for grids and cards. */
export function fmtDay(date: string | null | undefined, lang: 'en' | 'hi', withYear = false): string {
  if (!date) return '—';
  const key = `${lang}:${withYear}`;
  let f = shortFmt.get(key);
  if (!f) {
    f = new Intl.DateTimeFormat(lang === 'hi' ? 'hi-IN' : 'en-GB', {
      day: 'numeric',
      month: 'short',
      ...(withYear ? { year: '2-digit' } : {}),
      timeZone: 'UTC',
    });
    shortFmt.set(key, f);
  }
  return f.format(new Date(`${date}T00:00:00Z`));
}
